import { useEffect, useRef } from 'react';
import { useAccount } from '../../contexts/AccountContext';
import { forgetOrderTraces } from './orderStorage';

/**
 * Van ingelogd naar uitgelogd (zelf uitgelogd, of de sessie verliep): de bewaarde bevestiging en
 * poging-id van deze browser opruimen. Rendert niets. Staat in de winkel, niet in AccountContext,
 * omdat de gedeelde app-laag de afrekenmap niet kent.
 */
export function ForgetOrderOnSignOut() {
  const {
    status,
    signedIn
  } = useAccount();
  const wasSignedIn = useRef(false);
  useEffect(() => {
    if (status !== 'ready') return;
    if (wasSignedIn.current && !signedIn) forgetOrderTraces();
    wasSignedIn.current = signedIn;
  }, [status, signedIn]);
  return null;
}